import { useState } from "react";
import { PROGRAMS } from "@/data/programs";
import { Check, ArrowRight } from "lucide-react";
import ProgramApplicationDialog from "@/components/ProgramApplicationDialog";

export default function Programs() {
  const [active, setActive] = useState(null);

  return (
    <div data-testid="programs-page">
      <section className="section">
        <div className="container-editorial">
          <div className="eyebrow">Programs</div>
          <h1 className="mt-4 font-serif text-5xl leading-[1.05] text-ink md:text-6xl">
            Four pathways. <em className="not-italic text-clay">One community.</em>
          </h1>
          <p className="mt-6 max-w-2xl text-lg leading-relaxed text-ink-muted">
            Each program is cohort-based, mentor-led, and rooted in dignity. Applications are reviewed within a week
            and every applicant hears back — even if this season isn't the right fit.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="container-editorial space-y-16 px-6 md:px-10">
          {PROGRAMS.map((p, idx) => (
            <article
              key={p.slug}
              id={p.slug}
              data-testid={`program-${p.slug}`}
              className={`grid grid-cols-1 items-center gap-10 lg:grid-cols-12 ${idx % 2 === 1 ? "lg:[&>div:first-child]:order-2" : ""}`}
            >
              <div className="lg:col-span-6">
                <div className="overflow-hidden rounded-3xl border border-clay/15">
                  <img src={p.image} alt={p.name} className="aspect-[5/4] w-full object-cover" />
                </div>
              </div>
              <div className="lg:col-span-6">
                <div className="eyebrow">{`0${idx + 1} / ${PROGRAMS.length}`}</div>
                <h2 className="mt-2 font-serif text-4xl leading-tight text-ink md:text-5xl">{p.name}</h2>
                <p className="mt-3 font-serif text-xl italic text-clay">{p.tagline}</p>
                <p className="mt-5 leading-relaxed text-ink-muted">{p.description}</p>
                <ul className="mt-6 grid grid-cols-1 gap-3 sm:grid-cols-2">
                  {p.highlights.map((h) => (
                    <li key={h} className="flex items-start gap-3 rounded-xl border border-clay/10 bg-white px-4 py-3 text-sm text-ink">
                      <Check className="mt-0.5 h-4 w-4 shrink-0 text-sage" />
                      <span>{h}</span>
                    </li>
                  ))}
                </ul>
                <div className="mt-8 flex flex-wrap gap-3">
                  <button
                    type="button"
                    data-testid={`apply-${p.slug}`}
                    onClick={() => setActive(p)}
                    className="btn-primary"
                  >
                    Apply to {p.name} <ArrowRight className="h-4 w-4" />
                  </button>
                  <a href="#programs-top" className="btn-ghost">Back to top</a>
                </div>
              </div>
            </article>
          ))}
        </div>
      </section>

      <ProgramApplicationDialog open={!!active} onOpenChange={(v) => !v && setActive(null)} program={active} />
    </div>
  );
}
